var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("PaginationController", {
        ref: "historyTable",
        attrs: {
          getDataActionName: "getHistoryScannedItems",
          historyLimit: _vm.historyLimit,
          haveStartDate: _vm.filterBy !== "tracking",
          haveNoEndDate: _vm.filterBy === "tracking",
          actionPredicates: _vm.historyItemPredicates
        },
        scopedSlots: _vm._u([
          {
            key: "dataTable",
            fn: function() {
              return [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.historyScannedItems,
                    "item-key": "_key",
                    "hide-actions": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.type))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(_vm.carrierMap[props.item.carrier]))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(_vm.serviceTypeMap[props.item.serviceType])
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(
                                props.item.trackings &&
                                  props.item.trackings.length
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(
                                _vm.toDateYYYYMMDDHHmm(props.item.createTime)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(_vm.getSiteNameFromKey(props.item.siteKey))
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.workerName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary", flat: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.showEditlDialog(props.item)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("edit")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary", flat: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.showDetailDialog(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("details")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                })
              ]
            },
            proxy: true
          },
          {
            key: "beforeMenu",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  { attrs: { "align-baseline": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs3: "", "mr-3": "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            items: [
                              { name: _vm.$t("type"), value: "type" },
                              { name: _vm.$t("tracking"), value: "tracking" }
                            ],
                            "item-value": "value",
                            "item-text": "name",
                            label: _vm.$t("filterBy")
                          },
                          model: {
                            value: _vm.filterBy,
                            callback: function($$v) {
                              _vm.filterBy = $$v
                            },
                            expression: "filterBy"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.filterBy === "type"
                      ? _c(
                          "v-flex",
                          { attrs: { xs3: "", "mr-3": "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                items: [
                                  { name: _vm.$t("inbound"), value: "inbound" },
                                  {
                                    name: _vm.$t("outbound"),
                                    value: "outbound"
                                  }
                                ],
                                "item-value": "value",
                                "item-text": "name",
                                label: "Type"
                              },
                              model: {
                                value: _vm.typeFilter,
                                callback: function($$v) {
                                  _vm.typeFilter = $$v
                                },
                                expression: "typeFilter"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterBy === "type"
                      ? _c(
                          "v-flex",
                          { attrs: { xs3: "", "mr-3": "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                items: [
                                  { name: "-- ALL --", value: "" }
                                ].concat(
                                  Object.entries(_vm.carrierMap).map(function(
                                    ref
                                  ) {
                                    var key = ref[0]
                                    var value = ref[1]

                                    return {
                                      name: value,
                                      value: key
                                    }
                                  })
                                ),
                                "item-value": "value",
                                "item-text": "name",
                                label: _vm.$t("carrier")
                              },
                              model: {
                                value: _vm.carrierFilter,
                                callback: function($$v) {
                                  _vm.carrierFilter = $$v
                                },
                                expression: "carrierFilter"
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "v-flex",
                          { attrs: { xs5: "" } },
                          [
                            _c("v-text-field", {
                              attrs: { label: _vm.$t("searchByTracking") },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return function() {
                                    return _vm.$refs[
                                      "historyTable"
                                    ].$$initiateTable()
                                  }.apply(null, arguments)
                                }
                              },
                              model: {
                                value: _vm.trackingFilter,
                                callback: function($$v) {
                                  _vm.trackingFilter = $$v
                                },
                                expression: "trackingFilter"
                              }
                            })
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "primary",
                          small: "",
                          disabled: _vm.historyScannedItems.length === 0
                        },
                        on: { click: _vm.exportToExcel }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("export")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.historyScannedItems,
          callback: function($$v) {
            _vm.historyScannedItems = $$v
          },
          expression: "historyScannedItems"
        }
      }),
      _vm._v(" "),
      _vm.itemEditDialog
        ? _c("PrescanHistoryEditPopup", {
            attrs: {
              item: _vm.itemInEdit,
              carrierMap: _vm.carrierMap,
              serviceTypeMap: _vm.serviceTypeMap
            },
            on: { onSubmitted: _vm.updateItem },
            model: {
              value: _vm.itemEditDialog,
              callback: function($$v) {
                _vm.itemEditDialog = $$v
              },
              expression: "itemEditDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.itemDetailDialog
        ? _c(
            "ChatRoom",
            _vm._b(
              {
                attrs: {
                  title: _vm.$t("details"),
                  enableFileUpload: "",
                  createConnection: ""
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "issue",
                      fn: function() {
                        return [
                          _c(
                            "v-card",
                            { attrs: { hover: "", raised: "" } },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { xs6: "" } }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("createTime")) + ": "
                                          )
                                        ]),
                                        _vm._v(
                                          "  " +
                                            _vm._s(
                                              _vm.toDateYYYYMMDDHHmm(
                                                _vm.itemInEdit.createTime
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("v-flex", { attrs: { xs6: "" } }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("quantity")) + ": "
                                          )
                                        ]),
                                        _vm._v(
                                          "  " +
                                            _vm._s(
                                              _vm.itemInEdit.trackings &&
                                                _vm.itemInEdit.trackings.length
                                            ) +
                                            "\n            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("v-flex", { attrs: { xs6: "" } }, [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.$t("type")) + ": ")
                                        ]),
                                        _vm._v(
                                          "  " +
                                            _vm._s(_vm.itemInEdit.type) +
                                            "\n            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("v-flex", { attrs: { xs6: "" } }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("carrier")) + ": "
                                          )
                                        ]),
                                        _vm._v(
                                          "  " +
                                            _vm._s(_vm.itemInEdit.carrier) +
                                            "\n            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("v-flex", { attrs: { xs6: "" } }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("workerName")) + ": "
                                          )
                                        ]),
                                        _vm._v(
                                          "  " +
                                            _vm._s(_vm.itemInEdit.workerName) +
                                            "\n            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("v-flex", { attrs: { xs6: "" } }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("serviceType")) + ": "
                                          )
                                        ]),
                                        _vm._v(
                                          "  " +
                                            _vm._s(
                                              _vm.serviceTypeMap[
                                                _vm.itemInEdit.serviceType
                                              ]
                                            ) +
                                            "\n            "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.$t("note")) + ": ")
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticStyle: {
                                            "white-space": "pre-wrap",
                                            overflow: "auto",
                                            "word-wrap": "break-word"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.itemInEdit.note))]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", { attrs: { "my-1": "" } }),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c("v-flex", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("trackings")) + ":"
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    _vm._l(_vm.itemInEdit.trackings, function(
                                      tracking
                                    ) {
                                      return _c(
                                        "v-flex",
                                        { key: tracking, attrs: { xs4: "" } },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                (
                                                  _vm.itemInEdit
                                                    .uploadedTrackings || []
                                                ).includes(tracking) ||
                                                _vm.itemInEdit.type ===
                                                  "outbound"
                                                  ? ""
                                                  : "non-uploaded-tracking"
                                            },
                                            [_vm._v(_vm._s(tracking))]
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    _vm._l(
                                      _vm.itemInEdit.uploadedFiles,
                                      function(file, index) {
                                        return _c("FsFileChip", {
                                          key: "file" + index,
                                          staticClass: "ma-2",
                                          attrs: {
                                            file: file,
                                            width: "100%",
                                            "aspect-ratio": "1.7"
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  155771732
                ),
                model: {
                  value: _vm.itemDetailDialog,
                  callback: function($$v) {
                    _vm.itemDetailDialog = $$v
                  },
                  expression: "itemDetailDialog"
                }
              },
              "ChatRoom",
              _vm.chatRoomBind,
              false
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fd985a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd985a1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrescanHistoryTab.vue
// module id = null
// module chunks = 